<!-- footer-->
<footer class="c-footer c-footer--login" style="width: auto;">
  <div class="c-footer__inner">
    <p class="c-footer__copyright">Copyright© INTERSERVE Corpolation. All rights reserved.</p>
  </div>
</footer>
<!-- /footer-->
